// import React, { useEffect, useRef } from "react";
// import * as d3 from "d3";

// const DonutChart = ({
//   width = 120,
//   height = 120,
//   data = [],
//   colors = ["#FFA500", "#B266FF"],
//   valueKey = "value",
//   labelKey = "label",
//   showTooltip = true,
// }) => {
//   const ref = useRef();

//   useEffect(() => {
//     if (!data?.length) return;

//     const radius = Math.min(width, height) / 2;
//     const innerRadius = radius * 0.65;

//     const svg = d3
//       .select(ref.current)
//       .attr("width", width)
//       .attr("height", height)
//       .html("")
//       .append("g")
//       .attr("transform", `translate(${width / 2}, ${height / 2})`);

//     const pie = d3
//       .pie()
//       .sort(null)
//       .padAngle(0.03)
//       .value((d) => d[valueKey]);

//     const arc = d3
//       .arc()
//       .innerRadius(innerRadius)
//       .outerRadius(radius)
//       .cornerRadius(8); // rounded ends

//     const colorScale = d3.scaleOrdinal().range(colors);

//     const arcs = svg
//       .selectAll("path")
//       .data(pie(data))
//       .enter()
//       .append("path")
//       .attr("d", arc)
//       .attr("fill", (_, i) => colorScale(i))
//       .attr("stroke", "#fff")
//       .attr("stroke-width", 2);

//     if (showTooltip) {
//       const tooltip = d3
//         .select("body")
//         .append("div")
//         .attr("class", "absolute text-xs px-2 py-1 rounded shadow bg-white border border-gray-300")
//         .style("display", "none");

//       arcs
//         .on("mouseover", function (event, d) {
//           tooltip
//             .style("display", "block")
//             .html(`${d.data[labelKey]}: <b>${d.data[valueKey]}</b>`);
//         })
//         .on("mousemove", function (event) {
//           tooltip
//             .style("left", event.pageX + 10 + "px")
//             .style("top", event.pageY - 20 + "px");
//         })
//         .on("mouseout", () => tooltip.style("display", "none"));
//     }
//   }, [data, width, height]);

//   return <svg ref={ref} className="overflow-visible" />;
// };

// export default DonutChart;


import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

const DonutChart = ({
  width = 120,
  height = 120,
  data = [],
  colors = ["#FFA500", "#B266FF"],
  valueKey = "value",
  labelKey = "label",
  showTooltip = true,
}) => {
  const ref = useRef();

  useEffect(() => {
    // --- Default values for empty data ---
    const safeData =
      data.length > 0
        ? data.map((d) => ({ ...d, [valueKey]: d[valueKey] || 0 }))
        : [{ [labelKey]: "No Data", [valueKey]: 0 }];

    const radius = Math.min(width, height) / 2;
    const innerRadius = radius * 0.65;

    const svg = d3
      .select(ref.current)
      .attr("width", width)
      .attr("height", height)
      .html("")
      .append("g")
      .attr("transform", `translate(${width / 2}, ${height / 2})`);

    const pie = d3
      .pie()
      .sort(null)
      .padAngle(0.03)
      .value((d) => d[valueKey]);

    const arc = d3
      .arc()
      .innerRadius(innerRadius)
      .outerRadius(radius)
      .cornerRadius(8);

    const colorScale = d3.scaleOrdinal().range(colors);

    const arcs = svg
      .selectAll("path")
      .data(pie(safeData))
      .enter()
      .append("path")
      .attr("d", arc)
      .attr("fill", (_, i) => colorScale(i))
      .attr("stroke", "#fff")
      .attr("stroke-width", 2);

    if (showTooltip) {
      const tooltip = d3
        .select("body")
        .append("div")
        .attr(
          "class",
          "absolute text-xs px-2 py-1 rounded shadow bg-white border border-gray-300"
        )
        .style("display", "none");

      arcs
        .on("mouseover", function (event, d) {
          tooltip
            .style("display", "block")
            .html(`${d.data[labelKey]}: <b>${d.data[valueKey]}</b>`);
        })
        .on("mousemove", function (event) {
          tooltip
            .style("left", event.pageX + 10 + "px")
            .style("top", event.pageY - 20 + "px");
        })
        .on("mouseout", () => tooltip.style("display", "none"));
    }
  }, [data, width, height]);

  return <svg ref={ref} className="overflow-visible" />;
};

export default DonutChart;
